/* RESPONSIBLE TEAM: team-conversations */
import type RouterService from '@ember/routing/router-service';
import { inject as service } from '@ember/service';
import { ReactRoute } from 'embercom/lib/react-route';
import ProductSettingsRoute from 'embercom/routes/apps/app/settings/base/product-settings-route';
import type AppService from 'embercom/services/app-service';

class ExportDataRoute extends ProductSettingsRoute {
  @service declare appService: AppService;
  @service declare router: RouterService;

  reactEnabled() {
    return true;
  }

  beforeModel() {
    if (!this.appService.app.useBulkExportNewUI) {
      this.router.transitionTo('apps.app.settings.data.imports-exports.index', {
        queryParams: { tab: 'export-data' },
      });
    }
  }
}

export default ReactRoute(ExportDataRoute);
